export enum CoinSource {
  'question' = 0,
  'notes' = 1,
}

export class CreateStudentCoinDto {
  coinSource: CoinSource;

  amount: number;
}
